import { getClient } from '@/api/api.js'
export default {
  install(Vue) {
    Vue.$graphqlCore =  Vue.prototype.$graphqlCore = {
      getClient: getClient
    } 
  }
}